export default __webpack_public_path__ + "static/media/android.21ba8446.svg";